import React from 'react';
import {
  Box,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
} from '@mui/material';
import { Search } from '@mui/icons-material';

interface CourseFiltersProps {
  searchTerm: string;
  selectedVersion: string;
  courseCount: number;
  onSearchChange: (value: string) => void;
  onVersionChange: (value: string) => void;
}

const CourseFilters: React.FC<CourseFiltersProps> = ({
  searchTerm,
  selectedVersion,
  courseCount,
  onSearchChange,
  onVersionChange,
}) => {
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, mb: 3 }}>
      <Box sx={{ flex: '1 1 300px', minWidth: '300px' }}>
        <TextField
          fullWidth
          label="Search courses, tutors, or course types"
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          InputProps={{
            startAdornment: <Search sx={{ mr: 1, color: 'text.secondary' }} />
          }}
        />
      </Box>
      <Box sx={{ flex: '0 0 120px', minWidth: '120px' }}>
        <FormControl fullWidth>
          <Select
            value={selectedVersion}
            onChange={(e) => onVersionChange(e.target.value)}
            displayEmpty
            size="medium"
          >
            <MenuItem value="all">All Versions</MenuItem>
            <MenuItem value="v1.x">v1.x (Legacy)</MenuItem>
            <MenuItem value="v2.x">v2.x (CST Only)</MenuItem>
          </Select>
        </FormControl>
      </Box>
      <Box sx={{ flex: '1 1 200px', display: 'flex', alignItems: 'center' }}>
        <Typography variant="body2" color="text.secondary">
          {courseCount} active course{courseCount !== 1 ? 's' : ''} found
        </Typography>
      </Box>
    </Box>
  );
};

export default CourseFilters;
